var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.user.email)?_c('siteNavigation'):_vm._e(),(_vm.user.email)?_c('imageBanner',{attrs:{"title":"Pricing Calculator"}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }